export const getFieldName = (fieldNum) => `field_${fieldNum}`;

export const urlToFile = (url, filename, mimeType) => {
  return (fetch(url)
    .then(function (res) {
      // console.log('res', res);
      return res.arrayBuffer();
    })
    .then(function (buf) {
      // console.log('buf', buf);
      return new File([buf], filename, { type: mimeType });
    })
  );
}

export const urlBlobToFile = (url, filename, mimeType) => {
  return (fetch(url)
    .then(r => {
      // console.log('r', r)
      return r.blob();
    })
    // .then(blobFile => )
    .then(blobFile => {
      // return new File([blobFile], filename, { type: mimeType });
      // console.log('blobFile', blobFile)

      return blobFile;
    })
  );
}

export const plainTypes = ['TEXT', 'NUMBER', 'SWITCH', 'DATE', 'EMAIL', 'PHONE', 'STAR-RATING', 'EMOJI-RATING', 'NUMBER-RANGE'];

// Returns true if the given answer field value selects an option marked as
// `disqualify` in the admin. For single-choice types (RADIO/COMBOBOX/SELECT)
// `result` is the chosen option object; for multi-choice types
// (CHECKBOX/MULTI-INPUT/multi SELECT/IMAGE-SELECT) it is an array of options.
export const hasDisqualifyingAnswer = (fieldValue) => {
  const result = fieldValue?.result;
  if (!result) {
    return false;
  }
  if (Array.isArray(result)) {
    return result.some(option => option?.disqualify === true);
  }
  return result?.disqualify === true;
};

// Answer options whose display order may be randomized. "Other" (CUSTOM_OPTION)
// and "None of the above" (CANCEL_OPTION) are intentionally excluded so they
// stay pinned at the end.
const SHUFFLEABLE_OPTION_TYPES = ['OPTION', 'IMAGE_OPTION'];

// Fisher-Yates shuffle over a copy of the given array.
const shuffle = (items) => {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

// Returns a new questions array where every question flagged `rotateAnswer`
// has its answer options randomized. Only plain OPTION/IMAGE_OPTION entries are
// shuffled in place; CUSTOM_OPTION/CANCEL_OPTION and all non-option attributes
// (headers, MIN/MAX, etc.) keep their original positions. Ids are preserved, so
// selection/next-question logic (which keys on id) is unaffected. Called once at
// load time so the order stays stable across Back/Next navigation.
export const rotateQuestionAnswers = (questions) => {
  if (!Array.isArray(questions)) {
    return questions;
  }
  return questions.map(question => {
    if (!question?.rotateAnswer || !Array.isArray(question.attributes)) {
      return question;
    }
    const shuffleablePositions = [];
    const shuffleableOptions = [];
    question.attributes.forEach((attribute, index) => {
      if (SHUFFLEABLE_OPTION_TYPES.includes(attribute?.typeName)) {
        shuffleablePositions.push(index);
        shuffleableOptions.push(attribute);
      }
    });
    if (shuffleableOptions.length < 2) {
      return question;
    }
    const shuffled = shuffle(shuffleableOptions);
    const attributes = [...question.attributes];
    shuffleablePositions.forEach((position, i) => {
      attributes[position] = shuffled[i];
    });
    return { ...question, attributes };
  });
};